import { GlButton, GlLoadingIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'WorkItemChildrenLoadMore',
    components: {
        GlButton,
        GlLoadingIcon
    },
    props: {
        fetchNextPageInProgress: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'fetch-next-page'
    ]
};
